import { mapActions } from "vuex";
import handleNextField from "@utils/handle-next-field";
// import goToWithScroll from "../utils/go-to-with-scroll";
// import scrollBy from "../utils/scroll-by";

export const defaultField = {
  component: null,
  attrs: {
    label: "",
    name: "",
  },
  options: [],
  validation: {},
  errorMessages: [],
};

export const FormMixinDefault = {
  data() {
    return {
      generalError: false,
      messageError: "",
      data: {},
    };
  },
  updated() {
    // if (!this.$v.$anyError) {
    //   goToWithScroll.call(this, scrollBy);
    // }
  },
  mounted() {
    this.data = this.fields.reduce(
      (prev, field) => ({
        ...prev,
        [field.attrs.name]:
          field.attrs.value !== undefined && field.attrs.value !== null
            ? field.attrs.value
            : "",
      }),
      {}
    );

    this.fetchData();
  },
  computed: {
    fieldsWithDefaults() {
      return this.fields.map(x => ({ ...defaultField, ...x }));
    },
    getMessageError() {
      return this.messageError === ""
        ? "Não conseguimos concluir a requisição, tente novamente."
        : this.messageError;
    },
  },
  methods: {
    ...mapActions({
      fetchApi: "api",
    }),
    handleNextField: (e, options, validation, mask) =>
      handleNextField(e, options, validation, mask),
    async submit() {
      this.$v.$touch();
      if (this.$v.$error) return;
      this.handleSubmit();
    },
    formUtils() {
      async function fetch(entity, action, payload, callbackFunc = () => {}) {
        try {
          if (!payload)
            throw new Error("parametro 'payload' não pode ser vazio!");
          if (!entity)
            throw new Error("parametro 'entity' não pode ser vazio!");
          if (!action)
            throw new Error("parametro 'action' não pode ser vazio!");

          const { data } = await this.fetchApi({
            entity,
            action,
            payload,
          });
          callbackFunc({ ...data });
          return { retorno: { ...data }, error: false };
        } catch (err) {
          callbackFunc({ retorno: err, error: true });
          return { retorno: { ...err }, error: true };
          // throw new Error(err);
        }
      }

      async function goToNextPage(UrlRedirect) {
        try {
          await this.$router.push(UrlRedirect);
        } catch (error) {
          throw new Error(error);
        }
      }

      return {
        fetch,
        goToNextPage,
      };
    },
  },
  validations() {
    const data = this.fieldsWithDefaults
      .filter(x => x.validation)
      .reduce(
        (prev, field) => ({
          ...prev,
          [field.attrs.name]: field.validation,
        }),
        {}
      );
    return { data };
  },
};
